import Thunk, { ThunkConfig } from 'src/thunks/index';
import { Callback, Data, List } from 'src/interfaces/general';
import noteActions from 'src/store/model/note';
import { fetchAndCheckClassUser, fetchClassById } from 'src/thunks/classes';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { AxiosError } from 'axios';
import { downloadTxtUrl } from 'src/utils/helper';
import dayjs from 'src/libs/dayjs';
import { DATE_TIME_FORMAT } from 'src/constants/app';
import { fetchTopicContentById } from 'src/thunks/topic_content';

const note = new Thunk('user_notes');

export type NotePayload = Partial<Model.Note>;

export const fetchNotes = note.fetch<List<Model.Note>, SearchParams.Note>({
  onSuccess({ data, dispatch }) {
    dispatch(noteActions.updateEntities(data.data));
  },
});

export const createNote = note.create<Data<Model.Note>, NotePayload>({
  onSuccess({ data, dispatch }) {
    dispatch(noteActions.updateEntity(data.data));
  },
});

export const updateNote = note.update<Data<Model.Note>, NotePayload>({
  onSuccess({ data, dispatch }) {
    dispatch(noteActions.updateEntity(data.data));
  },
});

export const deleteNote = note.remove<Data<Model.Note>, NotePayload>({
  onSuccess({ args, dispatch }) {
    dispatch(noteActions.removeEntity(args));
  },
});

export const fetchResources = note.fetchResources<void, SearchParams.Note>(
  'user_notes',
  async (arg, { dispatch, getState }) => {
    await fetchAndCheckClassUser(arg.class_id!, dispatch, getState());

    await Promise.all([
      dispatch(fetchClassById({ id: arg.class_id! })),
      dispatch(fetchTopicContentById({ id: arg.class_topic_content_id! })),
      dispatch(
        fetchNotes({
          ...arg,
          user_id: getState().ui.app.me?.id,
          order_by: 'created_at,desc',
        }),
      ),
    ]);
  },
);

export type DownloadNote = {
  class_topic_content_id: string;
  fileName: string;
};

export const downloadNote = createAsyncThunk<
  void,
  Callback<void, DownloadNote>,
  ThunkConfig
>(
  'user_notes/download',
  async (
    { class_topic_content_id, onError, onSuccess, fileName },
    { dispatch },
  ) => {
    try {
      const { data } = await note.post<Data<Model.UPLOAD_URL>>(
        'user_notes/download',
        { class_topic_content_id },
      );

      const { access_url } = data.data;

      await downloadTxtUrl(
        access_url,
        `${fileName}_${dayjs().format(DATE_TIME_FORMAT)}_notes.txt`,
      );
    } catch (err) {
      const error = err as AxiosError;
      onError?.({ dispatch, error });
    }
  },
);
